/* This file was generated automatically. Do not edit manually. */

export enum OnboardingAuditStatus {
    Completed = 'Completed',
    Advice = 'Advice',
    Incomplete = 'Incomplete',
    NoGo = 'NoGo',
    NotApplicable = 'NotApplicable',
}
